/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import { selectAuthAccountData } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import DefaultSelect from '../../../Common/Inputs/DefaultSelect';

class ParamsTasksInputs extends Component {
  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="panelGroupFilter_h_4">
          <a
            className="dropdown-toggle dropdown-toggle-collapse collapsed"
            role="button"
            data-toggle="collapse"
            href="#panelGroupFilter_c_4"
            aria-expanded="false"
            aria-controls="panelGroupFilter_c_4"
          >
            {t('Параметры задания')}
          </a>
        </div>
        <div
          aria-labelledby="panelGroupFilter_h_4"
          className="panel-collapse collapse in"
          id="panelGroupFilter_c_4"
          role="tabpanel"
          aria-expanded="true"
        >
          <div className="panel-body border-dashed-b">
            <div className="form-group m-b-0">
              <label className="control-label" htmlFor={'-'}>
                {t('Проверка')}:
              </label>
              <DefaultSelect
                btnClassName={'btn-sm'}
                selectArrItems={Object.keys(this.props.taskCheckTypes).map(
                  key => ({
                    value: key,
                    title: this.props.taskCheckTypes[key]
                  })
                )}
                value={this.props.selectQueryParams.check_type}
                selectTitleNullValue={t('Все')}
                handleChangeValue={value => {
                  this.changeQueryParams({ check_type: value });
                }}
              />
            </div>
          </div>
          <div className="panel-body border-t-0">
            <div className="form-group m-b-0">
              <label className="control-label" htmlFor={'-'}>
                {t('Многоразовость')}:
              </label>
              <DefaultSelect
                btnClassName={'btn-sm'}
                selectArrItems={[
                  {
                    value: 2,
                    title: t('Многоразовые')
                  },
                  {
                    value: 1,
                    title: t('Одноразовые')
                  }
                ]}
                value={this.props.selectQueryParams.executor_execution_interval}
                selectTitleNullValue={t('Все')}
                handleChangeValue={value => {
                  this.changeQueryParams(
                    {
                      executor_execution_interval: value
                    },
                    true
                  );
                }}
              />
            </div>
          </div>
          <div className="panel-body border-t-0">
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                id="checkboxNewOnly"
                type="checkbox"
                className="styled"
                checked={this.props.selectQueryParams.new_only === '1'}
                onChange={e => {
                  this.changeQueryParams(
                    {
                      new_only: e.target.checked ? '1' : '0'
                    },
                    true
                  );
                }}
              />
              <label htmlFor="checkboxNewOnly">{t('Только новые')}</label>
            </div>
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                id="checkboxFastChecking"
                type="checkbox"
                className="styled"
                checked={this.props.selectQueryParams.fast_checking === '15'}
                onChange={e => {
                  this.changeQueryParams(
                    {
                      fast_checking: e.target.checked ? '15' : null
                    },
                    true
                  );
                }}
              />
              <label htmlFor="checkboxFastChecking">
                {t('Быстрая проверка')}
              </label>
            </div>
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                id="checkboxOnlyForMyRating"
                type="checkbox"
                className="styled"
                checked={
                  this.props.selectQueryParams.only_for_my_rating === '1'
                }
                onChange={e => {
                  this.changeQueryParams(
                    {
                      only_for_my_rating: e.target.checked ? '1' : null
                    },
                    true
                  );
                }}
              />
              <label htmlFor="checkboxOnlyForMyRating">
                {t('Только для моего рейтинга')}
              </label>
            </div>
            {this.props.userAuthAccount.consentToAdultContent === 0 ? (
              <div className="checkbox abc-checkbox abc-checkbox-primary">
                <input
                  id="checkboxHideAdultContent"
                  type="checkbox"
                  className="styled"
                  checked={this.props.selectQueryParams.adult_content === '1'}
                  onChange={e => {
                    this.changeQueryParams(
                      {
                        adult_content: e.target.checked ? '1' : null
                      },
                      true
                    );
                  }}
                />
                <label htmlFor="checkboxHideAdultContent">
                  {t('Задания 18+')}
                </label>
              </div>
            ) : (
              <div className="checkbox abc-checkbox abc-checkbox-primary">
                <input
                  id="checkboxHideAdultContent"
                  type="checkbox"
                  className="styled"
                  checked={this.props.selectQueryParams.adult_content === '0'}
                  onChange={e => {
                    this.changeQueryParams(
                      {
                        adult_content: e.target.checked ? '0' : null
                      },
                      true
                    );
                  }}
                />
                <label htmlFor="checkboxHideAdultContent">
                  {t('Скрыть задания 18+')}
                </label>
              </div>
            )}
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                id="checkboxHideSoftwareInstall"
                type="checkbox"
                className="styled"
                checked={this.props.selectQueryParams.software_install === '0'}
                onChange={e => {
                  this.changeQueryParams(
                    {
                      software_install: e.target.checked ? '0' : null
                    },
                    true
                  );
                }}
              />
              <label htmlFor="checkboxHideSoftwareInstall">
                {t('Скрыть задания с ПО')}
              </label>
            </div>
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                id="checkboxExcludeGeoTargeting"
                type="checkbox"
                className="styled"
                checked={
                  this.props.selectQueryParams.exclude_geo_targeting === '1'
                }
                onChange={e => {
                  this.changeQueryParams(
                    {
                      exclude_geo_targeting: e.target.checked ? '1' : null
                    },
                    true
                  );
                }}
              />
              <label htmlFor="checkboxExcludeGeoTargeting">
                {t('Без геотаргетинга')}
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ParamsTasksInputs.propTypes = {
  // CONNECT
  selectQueryParams: PropTypes.shape({
    check_type: PropTypes.string,
    only_for_my_rating: PropTypes.string,
    executor_execution_interval: PropTypes.string,
    new_only: PropTypes.string,
    fast_checking: PropTypes.string,
    adult_content: PropTypes.string,
    software_install: PropTypes.string,
    exclude_geo_targeting: PropTypes.string
  }).isRequired,
  userAuthAccount: PropTypes.shape({
    consentToAdultContent: PropTypes.number.isRequired
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  taskCheckTypes: PropTypes.shape({}).isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName),
  userAuthAccount: selectAuthAccountData(state),
  taskCheckTypes: getItemFromRefList(state, 'taskCheckTypes')
});

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ParamsTasksInputs)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/ParamsTasksInputs/ParamsTasksInputs.js